var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntidades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#294fa9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconos nuevos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.45,321.71V75.45c0-8.76,3.51-12.3,12.16-12.3h144.8c8.45,0,12.1,3.64,12.1,12.07v77.43H248q27.35,0,54.69,0c7.58,0,11.45,3.87,11.45,11.47q0,76.76,0,153.5v4.09h8.77c6.58,0,11.11,4.08,11.11,9.94s-4.52,9.94-11.11,9.94h-257a9.8,9.8,0,0,1-9.17-5.32,9.24,9.24,0,0,1,.27-9.75,9.58,9.58,0,0,1,8.53-4.8C68.75,321.68,71.94,321.71,75.45,321.71ZM95.55,83.17V321.46h19.68c0-19.51,0-38.77,0-58,0-7.44,3.87-11.33,11.27-11.33h66.8c7.57,0,11.43,3.87,11.43,11.49q0,27.35,0,54.68v3.29h19.73V83.17ZM294,321.56V172.79H244.67V321.56ZM184.71,272.21H135.37v49.33h49.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145,93.17v19.45H115.45V93.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.59,93.2v19.51H175.15V93.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.92,133v19.5H115.48V133Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.12,132.89h29.44V152.4H175.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.4,172.68h29.44v19.55H115.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,192.21V172.7h29.44v19.51Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.92,212.53V232H115.48V212.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,232V212.5h29.56V232Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.15,192.65v19.5H254.71v-19.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.22,232.46v19.4H254.66v-19.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.66,272.13h29.48v19.51H254.66Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntidades);
export default __webpack_public_path__ + "static/media/entidades.2a3caaeaf304b2bae4a41b268082398e.svg";
export { ForwardRef as ReactComponent };